
import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, Plus } from 'lucide-react';

interface TranslationSearchProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onAddClick: () => void;
  translateFn: (key: string) => string;
}

const TranslationSearch: React.FC<TranslationSearchProps> = ({ 
  searchQuery, 
  onSearchChange,
  onAddClick,
  translateFn
}) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder={translateFn('translations.searchTranslations')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-8"
        />
      </div>
      <Button onClick={onAddClick} className="flex items-center gap-1">
        <Plus className="h-4 w-4" />
        <span>{translateFn('translations.addTranslation')}</span>
      </Button>
    </div>
  );
};

export default TranslationSearch;
